export const variables = {
    isInternational: true,
    countryId: 11,
  
    campaignId: 101,
    mktCodeId: "FCS2021ILDU",
    canalId: "30001e",
    payway: "fs",
    shipMode: null,
    monthlyPlanId:'2c93808479aa1b250179c23a60ab0678',
    sixMonthsPlanId: '2c93808479aa1b250179c23eb2f40679',
    annualPlanId: '2c93808479aa1ad30179c252fd7106a1',
    monthlyPlanName:'Mensual',
  sixMonthsPlanName: 'Semestral',
    annualPlanName: 'Anual',
    monthlyPlanPrice:'USD$2.99',
    sixMonthsPlanPrice: 'USD$2.39',
    sixMonthsPlanPricePerMonth: 'USD$14.34',
    sixMonthsOriginalPricePlanPerMonth: 'USD$17.94',
    annualPlanPrice: '599',
    monthlyPlanProductId: '4070000',
    monthlyPlanCampaignId: '30001',
    annualPlanProductId: '102',
    sixMonthsPlanProductId: '4070006',
    sixMonthsPlanCampaignId: '30002',
    currency: 'USD',
    currencySymbol: '$',
    paywaysImg: 'payways.png'
  };
  